<template>
  <div>
    <stocktypes
      :stocktypes="stockTypes"
      @stockTypeChange="getStockTypes()"
    ></stocktypes>
  </div>
</template>

<script>
import Api from "@/services/Api";
import StockType from "@/components/StockType.vue";

export default {
  components: {
    stocktypes: StockType
  },
  data() {
    return {
      stockTypes: []
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
        this.getStockTypes();
      
    },
    getStockTypes() {
      Api()
        .get("/stockType")
        .then(response => {
          this.stockTypes = response.data;
        });
    }
  }
};
</script>

<style>
</style>